import type { FeNodeType } from '../../generated/nodeDataTypes'

export type AssetCategory = 'script' | 'character' | 'location' | 'object'
  | 'storyboard' | 'video' | 'sound' | 'image' | 'timeline' | 'unsupported'

// Grouping is a view concern; generated types ensure new schemas require an
// explicit choice. Group containers/internal control nodes aren't asset rows.
const NODE_CATEGORIES = {
  audio: 'sound',
  characterDesigner: 'character',
  debugHang: null,
  director: null,
  generatedImageWithHistory: 'image',
  image: 'image',
  imageGenerator: 'image',
  locationDesigner: 'location',
  nodeGroup: null,
  objectDesigner: 'object',
  panelSource: 'storyboard',
  promptInput: 'script',
  scriptWriter: 'script',
  shortVideoGroup: null,
  soundExpert: 'sound',
  speechGenerator: 'sound',
  storyDirectionPreview: 'script',
  storyboardDesigner: 'storyboard',
  storyboardNoEnhanceDesigner: 'storyboard',
  styleSelector: null,
  text: 'script',
  video: 'video',
  videoEditor: 'timeline',
  videoGenerator: 'video',
  webtoonGroup: null,
  webtoonPanelGenerator: 'storyboard',
} satisfies Record<FeNodeType, AssetCategory | null>

const categoriesByType: Readonly<Record<string, AssetCategory | null>> = NODE_CATEGORIES

export function getSimplifiedCategory(type: string | undefined): AssetCategory | null {
  if (!type || !Object.prototype.hasOwnProperty.call(categoriesByType, type)) return 'unsupported'
  return categoriesByType[type]
}
